const loadingLabel = "Chargement";
const frFR = {
  loadingLabel
};
export {
  frFR as default,
  loadingLabel
};
